import { QuestionPageFormData } from '../screens/FunnelPage/QuestionPage/QuestionPageScreen';
import {
  QuestionPayload,
  QuestionResponse,
} from '../types/questionPageTypings';

export const questionPayloadFactory = (
  titlePage: string,
  active: boolean,
  data: QuestionPageFormData
): QuestionPayload => {
  return {
    cancellationFunnelId: Number(data.cancellationFunnelId),
    pageType: 'question',
    name: titlePage,
    active,
    content: {
      title: data.title,
      subtitle: data.subtitle,
      answers: data.answers.map(({ answer, finishFunnel, reasonId }) => ({
        answer,
        finishFunnel,
        reasonId: Number(reasonId),
      })),
      continueCancelationButtonTitle:
        data.continueCancelationButtonTitle ?? null,
      keepSubscriptionButtonTitle: data.keepSubscriptionButtonTitle ?? null,
    },
  };
};

export const questionFunnelsPagesResponseFactory = (
  response: QuestionResponse
) => {
  const body = {
    cancellationFunnelId: response.cancellationFunnelId,
    subtitle: response.content.subtitle,
    title: response.content.title,
    name: response.name,
    answers: response.content.answers.map(
      ({ answer, finishFunnel, reasonId }) => ({
        answer,
        reasonId: reasonId ? String(reasonId) : '',
        finishFunnel: finishFunnel ?? false,
      })
    ),
    continueCancelationButtonTitle:
      response.content.continueCancelationButtonTitle,
    keepSubscriptionButtonTitle: response.content.keepSubscriptionButtonTitle,
  };

  return body;
};
